var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome-view"},[_c('bgi-header'),_vm._m(0),_c('bgi-footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome-content"},[_c('h1',[_vm._v("Welcome to the Smart Skipper™ Web portal")])])
}]

export { render, staticRenderFns }